<template>
  <CToggleButton :active @update:active="active = true" :disabled :activeTheme :inactiveTheme class="c-radio-button">
    <slot/>
    <CRadioIcon :active :disabled :size/>
  </CToggleButton>
</template>

<script setup lang="ts">
  import CToggleButton from '../buttons/CToggleButton.vue';
  import CRadioIcon from './CRadioIcon.vue';
  import { Theme } from '@/shared/components/buttons/CButton.vue';

  withDefaults(defineProps<{
    disabled?: boolean;
    activeTheme?: Theme;
    inactiveTheme?: Theme;
    size?: number;
  }>(), {
    activeTheme: 'light-primary',
    inactiveTheme: 'normal-secondary',
  });

  const active = defineModel<boolean>('active');
</script>

<style lang="scss">
  .c-radio-button {
      &.c-button-normal-secondary.c-button-normal, &.c-button-light-primary.c-button-light {
        &.c-button.c-toggle-button:not(.c-button-disabled) {
          color: $neutral-800;
        }
      }

    justify-content: space-between;
    align-items: center;
    padding: .5rem;
  }
</style>